import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './ExamAttachList.css';
const cx = classNames.bind(styles);

class ExamAttachFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 구분 필터
    const attachCategory = [
      { 1: defineMessages(formatMessage({ id: 'ExamAttachList_15', defaultMessage: '실행파일' })) },
      { 2: defineMessages(formatMessage({ id: 'ExamAttachList_16', defaultMessage: '바로가기' })) },
      { 3: defineMessages(formatMessage({ id: 'ExamAttachList_17', defaultMessage: '문서파일' })) },
      { 4: defineMessages(formatMessage({ id: 'ExamAttachList_18', defaultMessage: '웹 문서' })) }
    ];

    const attachCategoryFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header content={defineMessages(formatMessage({ id: 'ExamAttachList_2', defaultMessage: '구분' }))} />
        {attachCategory.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.attachCategoryFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['attachCategoryArray'] &&
                    tempFilter['attachCategoryArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 훈련유형 필터
    const attachExamType = [
      { 1: defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' })) },
      { 2: defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })) },
      { 3: defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })) }
    ];

    const attachExamTypeFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
        />
        {attachExamType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.attachExamTypeFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['attachExamTypeArray'] &&
                    tempFilter['attachExamTypeArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 부가기능 필터
    const attachFunction = [{ PG: 'PG' }, { LG: 'LG' }, { PL: 'PL' }, { VS: 'VS' }];

    const attachFunctionFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamAttachList_5', defaultMessage: '부가 기능' }))}
        />
        {attachFunction.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.attachFunctionFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['attachFunctionArray'] &&
                    tempFilter['attachFunctionArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 제약사항 필터
    const attachRestrict = [
      { UAC: 'UAC' },
      { SS: 'SS' },
      { VD: 'VD' },
      { SF: 'SF' },
      { LC: 'LC' },
      { UC: 'UC' },
      { DW: 'DW' }
    ];

    const attachRestrictFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamAttachList_6', defaultMesssage: '제약 사항' }))}
        />
        {attachRestrict.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.attachRestrictFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['attachRestrictArray'] &&
                    tempFilter['attachRestrictArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    // 삭제여부 필터
    const isEnable = [{ 0: 'O' }, { 1: '-' }];

    const isEnableFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamAttachList_10', defaultMessage: '삭제 여부' }))}
        />
        {isEnable.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.isEnableFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['isEnableArray'] &&
                    tempFilter['isEnableArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let attachCategoryArray =
      paramData.getIn(['filter', 'attachCategoryArray']) && paramData.getIn(['filter', 'attachCategoryArray']).toJS();

    let attachExamTypeArray =
      paramData.getIn(['filter', 'attachExamTypeArray']) && paramData.getIn(['filter', 'attachExamTypeArray']).toJS();

    let attachFunctionArray =
      paramData.getIn(['filter', 'attachFunctionArray']) && paramData.getIn(['filter', 'attachFunctionArray']).toJS();

    let attachRestrictArray =
      paramData.getIn(['filter', 'attachRestrictArray']) && paramData.getIn(['filter', 'attachRestrictArray']).toJS();

    let isEnableArray =
      paramData.getIn(['filter', 'isEnableArray']) && paramData.getIn(['filter', 'isEnableArray']).toJS();

    if (attachCategoryArray === undefined) {
      attachCategoryArray = [];
    }
    if (attachExamTypeArray === undefined) {
      attachExamTypeArray = [];
    }
    if (attachFunctionArray === undefined) {
      attachFunctionArray = [];
    }

    if (attachRestrictArray === undefined) {
      attachRestrictArray = [];
    }

    if (isEnableArray === undefined) {
      isEnableArray = [];
    }

    const totalArrayLength =
      attachCategoryArray.length +
      attachExamTypeArray.length +
      attachFunctionArray.length +
      attachRestrictArray.length +
      isEnableArray.length;

    let attachCategoryInfo = null;
    let attachExamTypeInfo = null;
    let attachFunctionInfo = null;
    let attachRestrictInfo = null;
    let isEnableInfo = null;

    if (attachCategoryArray.length > 0) {
      attachCategoryInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamAttachList_2', defaultMessage: '구분' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {attachCategoryArray.map((attachCategory, index) => {
              const attachCategoryArray =
                paramData.getIn(['filter', 'attachCategoryArray']) &&
                paramData.getIn(['filter', 'attachCategoryArray']).toJS();

              let templateStatus = '';
              if (attachCategoryArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamAttachList_15', defaultMessage: '실행파일' }));
              } else if (attachCategoryArray[index] === '2') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamAttachList_16', defaultMessage: '바로가기' }));
              } else if (attachCategoryArray[index] === '3') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamAttachList_17', defaultMessage: '문서파일' }));
              } else if (attachCategoryArray[index] === '4') {
                templateStatus = defineMessages(formatMessage({ id: 'ExamAttachList_18', defaultMessage: '웹 문서' }));
              }

              const text =
                attachCategoryArray[attachCategoryArray.length - 1] !== attachCategoryArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (attachExamTypeArray.length > 0) {
      attachExamTypeInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {attachExamTypeArray.map((examType, index) => {
              const attachExamTypeArray =
                paramData.getIn(['filter', 'attachExamTypeArray']) &&
                paramData.getIn(['filter', 'attachExamTypeArray']).toJS();
              let templateStatus = '';
              if (attachExamTypeArray[index] === '1') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' })
                );
              } else if (attachExamTypeArray[index] === '2') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })
                );
              } else if (attachExamTypeArray[index] === '3') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })
                );
              }

              const text =
                attachExamTypeArray[attachExamTypeArray.length - 1] !== attachExamTypeArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (attachFunctionArray.length > 0) {
      attachFunctionInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamAttachList_5', defaultMesssage: '부가 기능' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {attachFunctionArray.map((linkAttach, index) => {
              const attachFunctionArray =
                paramData.getIn(['filter', 'attachFunctionArray']) &&
                paramData.getIn(['filter', 'attachFunctionArray']).toJS();

              const text =
                attachFunctionArray[attachFunctionArray.length - 1] !== attachFunctionArray[index]
                  ? attachFunctionArray[index] + ','
                  : attachFunctionArray[index];
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (attachRestrictArray.length > 0) {
      attachRestrictInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamAttachList_6', defaultMesssage: '제약 사항' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {attachRestrictArray.map((templateReceive, index) => {
              const attachRestrictArray =
                paramData.getIn(['filter', 'attachRestrictArray']) &&
                paramData.getIn(['filter', 'attachRestrictArray']).toJS();
              let templateStatus = '';
              if (attachRestrictArray[index] === '1') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_12', defaultMessage: '수신 성공' })
                );
              } else if (attachRestrictArray[index] === '2') {
                templateStatus = defineMessages(
                  formatMessage({ id: 'ExamTemplateList_34', defaultMessage: '수신 실패' })
                );
              }

              const text =
                attachRestrictArray[attachRestrictArray.length - 1] !== attachRestrictArray[index]
                  ? attachRestrictArray[index] + ','
                  : attachRestrictArray[index];
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }
    if (isEnableArray.length > 0) {
      isEnableInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'ExamAttachList_10', defaultMessage: '삭제 여부' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {isEnableArray.map((isEnable, index) => {
              const isEnableArray =
                paramData.getIn(['filter', 'isEnableArray']) && paramData.getIn(['filter', 'isEnableArray']).toJS();

              let templateStatus = '';
              if (isEnableArray[index] === '0') {
                templateStatus = 'O';
              } else if (isEnableArray[index] === '1') {
                templateStatus = '-';
              }

              const text =
                isEnableArray[isEnableArray.length - 1] !== isEnableArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {attachCategoryInfo}
        {attachExamTypeInfo}
        {attachFunctionInfo}
        {attachRestrictInfo}
        {isEnableInfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
              <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
            )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={5}>
              <Grid.Column textAlign="left">{attachCategoryFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{attachExamTypeFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{attachFunctionFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{attachRestrictFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{isEnableFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(ExamAttachFilter);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachFilter.js